// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unison-component .cu-modal-container {
  z-index: calc(1050 + 50);
}
.select-popover-scroll .cu-popover-content-container {
  max-height: 300px;
  overflow-y: auto;
}
.uia-bulk-actions {
  color: #fff;
  background-color: #007c92;
  height: 56px;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1030;
}
.uia-bulk-actions .cu-list-item {
  cursor: pointer;
  border: none;
  width: 100%;
  background: #fff;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions {
  align-items: center;
  display: flex;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .uia-more-button {
  color: #fff;
  cursor: pointer;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button {
  border: 2px solid #fff;
  color: #fff;
  font-weight: 600;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button:hover {
  background-color: #fff;
  color: #007c92;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button:hover .cu-white-loading-spinner circle {
  stroke: #007c92;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button:hover .cu-white-loading-spinner circle.cu-spinner-spiral {
  stroke: #007c92;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button .video-icon-wrapper {
  height: 14px;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button .cu-white-loading-spinner {
  width: 20px;
  height: 20px;
  margin: 0 8px 0 0;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button .cu-white-loading-spinner circle {
  stroke: #e9eaec;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .bulk-actions-top-bar-button .cu-white-loading-spinner circle.cu-spinner-spiral {
  stroke: #adb3b8;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .uia-menu-add-icon svg {
  vertical-align: sub;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .uia-menu-delete-icon svg {
  vertical-align: baseline;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .uia-downloads-list-item cu-popover-target {
  width: 100%;
  display: block;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .uia-downloads-list-item .bulk-actions-list-item-disabled {
  color: #bec3c7;
  cursor: auto;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions cu-popover-content-container {
  margin-top: 8px;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .videoicon svg {
  vertical-align: bottom;
}
.uia-bulk-actions .uia-bulk-actions-icon-actions .mute-disclaimer {
  background-color: #e9eaec;
  color: #4E495C;
  font-size: small;
}
.uia-bulk-actions .bulk-actions-icon-button {
  cursor: pointer;
  float: left;
  height: 20px;
  width: 20px;
}
.uia-bulk-actions .bulk-actions-icon-button.bulk-actions-clear-button {
  margin-left: 0;
}
.uia-bulk-actions .bulk-actions-icon-button.bulk-actions-clear-button cu-icon {
  vertical-align: bottom;
}
.uia-bulk-actions .bulk-actions-icon-button.bulk-actions-clear-button cu-icon svg {
  height: 20px;
  width: 20px;
}
.uia-bulk-actions .selected-items-count {
  float: left;
  font-size: 16px;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./app/bulk-actions/uia-bulk-actions/uia-bulk-actions.less"],"names":[],"mappings":"AAOA;EACI,wBAAA;AANJ;AASA;EAEQ,iBAAA;EACA,gBAAA;AARR;AAYA;EACI,WAAA;EAwHA,yBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EAIA,aAAA;AApIJ;AAGA;EAIQ,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAJR;AAHA;EAWQ,mBAAA;EACA,aAAA;AALR;AAPA;EAeY,WAAA;EACA,eAAA;AALZ;AAXA;EAoBY,sBAAA;EACA,WAAA;EACA,gBAAA;AANZ;AAQY;EACI,sBAAA;EACA,cAAA;AANhB;AAIY;EAMY,eAAA;AAPxB;AACY;EASY,eAAA;AAPxB;AA1BA;EAsCgB,YAAA;AAThB;AA7BA;EAyCgB,WAAA;EACA,YAAA;EACA,iBAAA;AAThB;AAlCA;EA8CoB,eAAA;AATpB;AArCA;EAkDoB,eAAA;AAVpB;AAxCA;EA0DgB,mBAAA;AAfhB;AA3CA;EAgEgB,wBAAA;AAlBhB;AA9CA;EAsEgB,WAAA;EACA,cAAA;AArBhB;AAlDA;EA2EgB,cAAA;EACA,YAAA;AAtBhB;AAtDA;EAiFY,eAAA;AAxBZ;AAzDA;EAqFgB,sBAAA;AAzBhB;AA5DA;EAyFY,yBAAA;EACA,cAAA;EACA,gBAAA;AA1BZ;AAjEA;EAgGQ,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA5BR;AA8BQ;EACI,cAAA;AA5BZ;AA2BQ;EAIQ,sBAAA;AA5BhB;AAwBQ;EAOY,YAAA;EACA,WAAA;AA5BpB;AAjFA;EAoHQ,WAAA;EACA,eAAA;EACA,gBAAA;AAhCR","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n\n// Required for bulk add labels modal in streams drawer\n.unison-component .cu-modal-container {\n    z-index: calc(@cu-zindex-modal + 50);\n}\n\n.select-popover-scroll{\n    .cu-popover-content-container{\n        max-height:300px;\n        overflow-y: auto;\n    } \n}\n\n.uia-bulk-actions {\n    color: @cu-white;\n\n    .cu-list-item {\n        cursor: pointer;\n        border: none;\n        width: 100%;\n        background: @cu-white;\n    }\n\n    .uia-bulk-actions-icon-actions {\n        align-items: center;\n        display: flex;\n\n        .uia-more-button {\n            color: @cu-white;\n            cursor: pointer;\n        }\n\n        .bulk-actions-top-bar-button {\n            border: 2px solid @cu-white;\n            color: @cu-white;\n            font-weight: 600;\n\n            &:hover {\n                background-color: @cu-white;\n                color: @cu-color-primary;\n\n                .cu-white-loading-spinner {\n                    circle {\n                        stroke: @cu-color-primary;\n                    }\n                    circle.cu-spinner-spiral {\n                        stroke: @cu-color-primary;\n                    }\n                }\n            }\n            .video-icon-wrapper{\n                height:14px;\n            }\n            .cu-white-loading-spinner {\n                width: 20px;\n                height: 20px;\n                margin: 0 @cu-spacing-2 0 0;\n\n                circle {\n                    stroke: @cu-gray-1;\n                }\n\n                circle.cu-spinner-spiral {\n                    stroke: @cu-gray-5;\n                }\n            }\n           \n        }\n\n        .uia-menu-add-icon {\n            svg {\n                vertical-align: sub;\n            }\n        }\n\n        .uia-menu-delete-icon {\n            svg {\n                vertical-align: baseline;\n            }\n        }\n\n        .uia-downloads-list-item {\n            cu-popover-target {\n                width: 100%;\n                display: block;\n            }\n\n            .bulk-actions-list-item-disabled {\n                color: @cu-gray-4;\n                cursor: auto;\n            }\n        }\n\n        cu-popover-content-container {\n            margin-top: 8px;\n        }\n        .videoicon{\n            svg{\n                vertical-align: bottom;\n            }\n        }\n        .mute-disclaimer{\n            background-color: @cu-gray-1;\n            color: @cu-gray-9;\n            font-size: small;\n          }\n    }\n\n    .bulk-actions-icon-button {\n        cursor: pointer;\n        float: left;\n        height: 20px;\n        width: 20px;\n\n        &.bulk-actions-clear-button {\n            margin-left: 0;\n\n            cu-icon {\n                vertical-align: bottom;\n\n                svg {\n                    height: 20px;\n                    width: 20px;\n                }\n            }\n        }\n    }\n\n    .selected-items-count {\n        float: left;\n        font-size: 16px;\n        font-weight: 700;\n    }\n\n    background-color: @cu-color-primary;\n    height: 56px;\n    left: 0;\n    right: 0;\n    top: 0;\n\n    // Make this render on top of other static page elements,\n    // fixes rendering bug on chrome\n    z-index: @cu-zindex-fixed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
